// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2RsJo","options":"AnswerScale_options__1h5c_","selected":"AnswerScale_selected__3kGSF"};